import { BLUEPRINT_NAMES } from './blueprintNameMapping.ts';
import { WHITEBOARD_TEMPLATE_IDS } from './whiteboardMappings.ts';

export const DEFAULT_POPULAR_TEMPLATES: (BLUEPRINT_NAMES | WHITEBOARD_TEMPLATE_IDS)[] = [
	BLUEPRINT_NAMES.PROJECT_PLAN,
	WHITEBOARD_TEMPLATE_IDS.BRAINWRITING,
	BLUEPRINT_NAMES.MEETING_NOTES,
	BLUEPRINT_NAMES.TEAM_POSTER,
	BLUEPRINT_NAMES.END_OF_WEEK_STATUS_REPORT,
	BLUEPRINT_NAMES.PRESENTER_MODE,
	BLUEPRINT_NAMES.HOW_TO_ARTICLE,
	BLUEPRINT_NAMES.TO_DO_LIST,
];
